
export const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

// 返回格式化后的日期字符串（YYYY-MM-DD）
export const getPreviousDate = (days) => {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - days);
    return currentDate.toISOString().split('T')[0];
};

// 返回格式为"YYYY-MM-DD HH:MM:SS"的字符串
export const getTimeBefore = (days) => {
    const now = new Date();
    now.setDate(now.getDate() - days);
    return now.toISOString().replace('T', ' ').substring(0, 19);
}

export const getPreviousDateRange = (daysOffset)=>  {
    const dateStr = getPreviousDate(daysOffset);
    const dayDate1 = dateStr + " 00:00:00";
    const dayDate2 = dateStr + " 23:59:59";
    return [dayDate1, dayDate2];
}

export const  getMonthRangeByCurrent = () => {
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth(), now.getDate()-1);
    // 时区修正
    const formatter = new Intl.DateTimeFormat('zh-CN', { timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit' });
    const firstDayStr = formatter.format(firstDay).replace(/\//g, '-');
    const lastDayStr = formatter.format(lastDay).replace(/\//g, '-');

    return [firstDayStr,lastDayStr];
}

export const getMonthRange = (monthsAgo)=> {
    const now = new Date();
    now.setMonth(now.getMonth() - monthsAgo);
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    // 时区修正
    const formatter = new Intl.DateTimeFormat('zh-CN', { timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit' });
    const firstDayStr = formatter.format(firstDay).split(' ')[0].replace(/\//g, '-');
    const lastDayStr = formatter.format(lastDay).split(' ')[0].replace(/\//g, '-');

    return [firstDayStr,lastDayStr];
}

export const getMonthRangeByYearAndMonth = (year,month)=> {

    const firstDay = new Date(year, month-1, 1);
    const lastDay = new Date(year, month, 0);

    // 时区修正
    const formatter = new Intl.DateTimeFormat('zh-CN', { timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit' });
    const firstDayStr = formatter.format(firstDay).split(' ')[0].replace(/\//g, '-');
    const lastDayStr = formatter.format(lastDay).split(' ')[0].replace(/\//g, '-');

    return [firstDayStr,lastDayStr];
}

export const  getCurrentMonth = (monthsAgo = 0) => {
    const now = new Date();
    now.setMonth(now.getMonth() - monthsAgo);
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
}